/**
 * RDS read configuration.
 * When USE_RDS_FOR_CORE_OBJECTS is true, core object reads go to RDS API instead of Gobodo.
 */

export const RDS_API_URL =
  process.env.REACT_APP_RDS_API_URL || process.env.RDS_API_URL || '';

export const USE_RDS_FOR_CORE_OBJECTS =
  process.env.REACT_APP_USE_RDS_FOR_CORE_OBJECTS === 'true' && !!RDS_API_URL;

/** Core objects that can be read from RDS (Salesforce standard objects). */
export const RDS_CORE_OBJECTS = new Set([
  'Account',
  'Contact',
  'Lead',
  'Opportunity',
  'Client',
  'Client__c',
  'Client__stg',
  'Product',
  'Partner',
]);

/** Normalize object name for RDS lookup (strip __c/__stg for table mapping). */
export function isRdsCoreObject(objectApiName: string): boolean {
  const base = objectApiName.replace(/__(c|stg)$/, '');
  return RDS_CORE_OBJECTS.has(objectApiName) || RDS_CORE_OBJECTS.has(base);
}
